import {Component, OnDestroy} from "@angular/core";
import {Subscription} from "rxjs/internal/Subscription";
import {FormBuilder, FormGroup} from "@angular/forms";
import {toastrService} from "../../../../services/ux/toastr.service";
import {WalletService} from "../../../../services/wallet.service";
import {ActivatedRoute} from "@angular/router";
import {ModalPaymentService} from "../../../../services/ux/modal-payment.service";
import {LocalStorage} from "../../../../services/local-storage";
import {finalize} from "rxjs/operators";
import {HttpErrorResponse} from "@angular/common/http";
import {KindergardenHttpClientService} from "../../../../data/kindergarden-http-client.service";
import {Kindergarden} from "../../../../models/SearchService/kindergarden.model";
import {AlbtelecomContract} from "../../../../models/SearchService/albtelecom-contract.model";
import {AlbtelecomContractHttpClientService} from "../../../../data/albtelecom-contract-http-client.service";
import { TranslateService } from "@ngx-translate/core";

@Component({
    templateUrl: "./albtelecom-contract.component.html"
})
export class AlbtelecomContractComponent implements OnDestroy {
    // region Subscriptions
    subscription: Subscription;
    ccSubscription: Subscription;
    finishTransactionSubscription: Subscription;
    // endregion

    searchForm: FormGroup;

    isLoading = false;

    hasParam = false;

    hasResults = false;

    private _albtelecomRecords: AlbtelecomContract[];
    public get albtelecomRecords(): AlbtelecomContract[] {
        return this._albtelecomRecords;
    }

    public set albtelecomRecords(value: AlbtelecomContract[]) {
        this._albtelecomRecords = value;
        this.hasResults = !!value.length;
    }

    // * payment
    selectedInvoice: AlbtelecomContract = {} as AlbtelecomContract;
    invoiceIndex: number;

    constructor(
        private fb: FormBuilder,
        private toastr: toastrService,
        private walletService: WalletService,
        private activeRoute: ActivatedRoute,
        private modalService: ModalPaymentService,
        private ls: LocalStorage,
        private http: AlbtelecomContractHttpClientService,
        private translateService: TranslateService
    ) {
        this.searchForm = this.fb.group({
            contractNumber: [""],
            type: [1]
        });

        this.subscription = walletService.$walletReadyEmitter.subscribe(
            (isReady: boolean) => {
                if (isReady) {
                    this.processAlbtelecomContractTransaction();
                }
            }
        );

        this.ccSubscription = walletService.$creditCardReadyEmitter.subscribe(
            (ccSelected: boolean) => {
                if (ccSelected) {
                    this.processAlbtelecomContractTransaction(ccSelected);
                }
            }
        );

        this.finishTransactionSubscription = walletService.$transactionFinish.subscribe(
            (value) => {
                if (value) {
                    this.removeFinishedTransactionFromRecords();
                }
            }
        );

        this.activeRoute.params.subscribe((params: {
            "number": number,
            searchType: number
        }) => {
            if (!(params.number || params.searchType)) {
                return;
            }

            this.fillSearchFromQueryParams(params);

            this.hasParam = true;
            this.onSearch();
        });
    }

    fillSearchFromQueryParams(params: {
        "number": number,
        searchType: number
    }) {
        this.searchForm.controls["contractNumber"].setValue(params.number);
        this.searchForm.controls["contractNumber"].disable();
        this.searchForm.controls["type"].setValue(params.searchType);
        this.searchForm.controls["type"].disable();
    }

    onSearch() {
        if (!this.searchForm.value.contractNumber || !this.searchForm.value.type) {
            return this.toastr.warning(this.translateService.instant("Services.FillInTheFields"));
        }

        this.isLoading = true;

        this.http
            .search(this.searchForm.value.type, this.searchForm.value.contractNumber)
            .pipe(
                finalize(() => {
                    this.isLoading = false;
                })
            )
            .subscribe({
                next: (response: AlbtelecomContract[]) => {
                    this.albtelecomRecords = response;
                },
                error: (error: HttpErrorResponse) => {
                    this.albtelecomRecords = [] as AlbtelecomContract[];
                    if (error.error === "invalid_parameters") {
                        this.toastr.warning(this.translateService.instant("Services.PleaseFillInTheFields"));
                    } else if (error.error === "no_invoices") {
                        this.toastr.warning(this.translateService.instant("Services.NoInvoicesFound"));
                    } else if (error.error === "search_fail") {
                        this.toastr.warning(this.translateService.instant("Services.SearchFailed"));
                    } else if (error.error === "contract_dont_exists") {
                        this.toastr.warning(this.translateService.instant("Services.SearchFailed"));
                    }
                }
            });
    }

    onPay(index: number) {
        this.invoiceIndex = index;
        this.selectedInvoice = this.albtelecomRecords[index];

        this.walletService.selectInvoice(this.selectedInvoice);
        this.walletService.amountOfTransaction = this.selectedInvoice.invoiceAmount + this.selectedInvoice.komision;

        this.modalService.open();
    }

    processAlbtelecomContractTransaction(creditCardMethod: boolean = false) {
        const albtelecomContractInvoice = {
            invoice: this.walletService.getInvoice(),
            ipAddress: "127.0.0.1",
            deviceId: "EternaWebPosta"
        };

        if (creditCardMethod) {
            this.http
                .payCC(albtelecomContractInvoice)
                .pipe(
                    finalize(() => {
                        this.isLoading = false;
                    })
                )
                .subscribe({
                    next: (response) => {
                        if (!response.data) {
                            this.walletService.emitTransactionProgress({
                                    isSuccess: false,
                                    error: response.error.message
                                }
                            );
                            return;
                        }
                        this.walletService.emitTransactionProgress(
                            {
                                isSuccess: true,
                                error: null
                            }
                        );
                        this.ls.set("sn", "kindergarden");

                        window.location = response.data.redirect;
                    },
                    error: (error: HttpErrorResponse) => {
                        const emmiterObject = {
                            isSuccess: false,
                            error: error.error.message
                        };

                        this.walletService.emitTransactionProgress(emmiterObject);
                    }
                });
        } else {
            this.http
                .payWallet(albtelecomContractInvoice)
                .pipe(
                    finalize(() => {
                        this.isLoading = false;
                    })
                )
                .subscribe({
                    next: () => {
                        const emmiterObject = {
                            isSuccess: true,
                            error: null
                        };

                        this.walletService.emitTransactionProgress(emmiterObject);
                    },
                    error: (error: HttpErrorResponse) => {
                        const emmiterObject = {
                            isSuccess: false,
                            error: error.error.message
                        };
                        this.walletService.emitTransactionProgress(emmiterObject);
                    }
                });
        }
    }

    private removeFinishedTransactionFromRecords() {
        this.albtelecomRecords.splice(this.invoiceIndex, 1);
    }

    constructDate(year: number, month: string): Date {
        const dateNameToNr = {
            "dhjetor": 12,
            "nentor": 11,
            "tetor": 10,
            "shtator": 9,
            "gusht": 8,
            "korrik": 7,
            "qershor": 6,
            "maj": 5,
            "prill": 4,
            "mars": 3,
            "shkurt": 2,
            "janar": 1,
        };
        const monthNr = dateNameToNr[month.toLowerCase()];
        return new Date(year, monthNr);
    }

    ngOnDestroy() {
        this.subscription.unsubscribe();
        this.ccSubscription.unsubscribe();
        this.finishTransactionSubscription.unsubscribe();
    }
}
